import type { RouteWithTitle } from '@pbk-web/types';
import { Roles } from '@pbk-web/types';
import { lazy } from 'react';

// Gated on the `playbook-forms-v2` PostHog flag (its evaluation context keeps it off in prod).
// The V2 builder is still a placeholder (Phase 3, PLAY-16085+); the panels demo is a dev harness.
const formsV2BuilderRoutes: RouteWithTitle[] = [
  {
    // V2 template builder. Mirrors the V1 `client-form-builder` shape: open an existing
    // template by id, or land on the empty builder. Reachable at
    // /clients/:clientId/forms-v2-builder[/:templateId].
    id: 'client-form-builder-v2',
    path: ['/clients/:clientId/forms-v2-builder/:templateId'],
    translationKey: 'page.forms-v2-builder',
    component: lazy(() => import('../pages/FormsV2BuilderPage')),
    // Any member: the template's own roles (Owner, Editor, …) gate it, and the API enforces them.
    // BuilderShell shows the API's 403/404 as the error page.
    permissions: [Roles.Employee, Roles.ExternalContributor, Roles.ExternalAuditor],
    postHogFlag: 'playbook-forms-v2',
  },
  {
    id: 'client-form-builder-v2-blank',
    path: ['/clients/:clientId/forms-v2-builder'],
    translationKey: 'page.forms-v2-builder',
    component: lazy(() => import('../pages/FormsV2BlankBuilderPage')),
    permissions: [Roles.TeamLead],
    canOverridePermissions: true,
    postHogFlag: 'playbook-forms-v2',
  },
  {
    // TEMPORARY harness: every action type's config editor bound to the type's real defaults,
    // with the live field + the PATCH body it would send. Nothing is saved.
    // Reachable at /clients/:clientId/forms-v2-panels-demo.
    id: 'forms-v2-panels-demo',
    path: '/clients/:clientId/forms-v2-panels-demo',
    translationKey: 'page.form-page',
    component: lazy(() => import('../pages/FormsV2PanelsDemoPage')),
    permissions: [Roles.Employee, Roles.ExternalContributor, Roles.ExternalAuditor],
    postHogFlag: 'playbook-forms-v2',
  },
  {
    // TEMPORARY harness: the property panel's save cadence against a mocked API — what becomes a
    // write, what the chrome says while one is in flight, and how a rejected write marks the field
    // that caused it. Nothing is persisted.
    // Reachable at /clients/:clientId/forms-v2-autosave-demo.
    id: 'forms-v2-autosave-demo',
    path: '/clients/:clientId/forms-v2-autosave-demo',
    translationKey: 'page.form-page',
    component: lazy(() => import('../pages/FormsV2AutosaveDemoPage')),
    permissions: [Roles.Employee, Roles.ExternalContributor, Roles.ExternalAuditor],
    postHogFlag: 'playbook-forms-v2',
  },
];

export default formsV2BuilderRoutes;
